module.exports = __webpack_public_path__ + "assets/img/37_1592.4ac49961.jpg";